export default __webpack_public_path__ + "static/media/1-8-16-maze.b310632f.m4a";